import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Typography,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  WarningOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

const ModalWorking = ({
  open,
  setVisible,
}) => {
  const onCancel = () => {
    setVisible(false);
  };

  return (
    <Modal
      title={(
        <FormSubmitControls
          label="PÁGINA NO DISPONIBLE"
          onCancel={onCancel}
        />
    )}
      className="modal-delete"
      open={open}
      closable={false}
      footer={false}
    >
      <div style={{ textAlign: 'center' }}>
        <WarningOutlined style={{ fontSize: 100, marginBottom: 16 }} />
      </div>
      <Text style={{ fontSize: 16 }}>
        Seguimos trabajando para ofrecerte un mejor sistema
      </Text>
    </Modal>
  );
};

ModalWorking.propTypes = {
  open: PropTypes.bool,
  setVisible: PropTypes.func.isRequired,
};

ModalWorking.defaultProps = {
  open: false,
};

export default ModalWorking;
